<!-- TEMPLATE -->
<template>
    <div :class='addressDetailsClass'>
        <dean-two-column-layout :title="headerTitle">
            <dean-section-title-item
              v-if="canSavePartnerAddress()"
              :icon='saveIcon'
              slot="title-items"
              :content="true"
              :large="true"
              @click.native="processAddress"
            >
                Opslaan
            </dean-section-title-item>

            <div class="column" slot="left">
                <dean-select-form-row placeholder="Kies een context" id='addressContext' label='Soort adres'
                                      :options='addressContextList' :value='currentAddressType'
                                      @input='addressTypeFieldChanged' :required-field="true"
                                      :disabled="! canSavePartnerAddress()"
                                      :warning="$v.data.addressContext.$error"
                                      @focus="$v.data.addressContext.$touch()"></dean-select-form-row>
                <dean-form-row id="attention" v-model="addressData.attention" label="T.a.v."
                               :disabled="! canSavePartnerAddress()"
                               @input="inputFieldChanged"></dean-form-row>
                <dean-form-row id="street" v-model="addressData.street" label="Straat" @input="inputFieldChanged"
                               :required-field="true"
                               :disabled="! canSavePartnerAddress()"
                               :warning="$v.data.street.$error"
                               @focus="$v.data.street.$touch()"></dean-form-row>
                <dean-form-row id="houseNumber" v-model="addressData.houseNumber" label="Huisnummer"
                               @input="inputFieldChanged" :required-field="true"
                               :disabled="! canSavePartnerAddress()"
                               :warning="$v.data.houseNumber.$error"
                               @focus="$v.data.houseNumber.$touch()"></dean-form-row>
                <dean-form-row id="houseNumberExtension" v-model="addressData.houseNumberExtension" label="Toevoeging huisnummer"
                               @input="inputFieldChanged" :required-field="false"
                               :disabled="! canSavePartnerAddress()"
                               :warning="$v.data.houseNumberExtension.$error"
                               @focus="$v.data.houseNumberExtension.$touch()"></dean-form-row>
                <dean-form-row id="postalCode" v-model="addressData.postalCode" label="Postcode"
                               @input="inputFieldChanged"
                               :required-field="true"
                               :disabled="! canSavePartnerAddress()"
                               :warning="$v.data.postalCode.$error"
                               @focus="$v.data.postalCode.$touch()"></dean-form-row>
                <dean-form-row id="city" v-model="addressData.city" label="Plaats" @input="inputFieldChanged"
                               :required-field="true"
                               :disabled="! canSavePartnerAddress()"
                               :warning="$v.data.city.$error"
                               @focus="$v.data.city.$touch()"></dean-form-row>
            </div>

            <div class="column" slot="right">

            </div>
        </dean-two-column-layout>
    </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {Component, Vue} from 'vue-property-decorator';
  import vSelect from 'vue-select';
  import axios from 'axios';
  import {required} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';
  import {postalCode, houseNumber} from '@/mixins/validators';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';

  import {
    businessIcon,
    commissionIcon,
    partnerIcon,
    deanAlertDialog,
    deanIcon,
    deanInputField,
    deanSearchField,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    invoicesIcon,
    messageIcon,
    offersIcon,
    ordersIcon,
    returnIcon,
    saveIcon,
    summeryIcon,
    usersIcon,
    warningIcon,
  } from '@deanone/dean-components';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {validationMixin} from 'vuelidate';

  @Component({
    components: {
      DeanSelectFormRow,
      deanAlertDialog,
      deanInputField,
      DeanTwoColumnLayout,
      deanInputSelect,
      deanFormRow,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      vSelect,
      invoicesIcon,
      deanIcon,
      returnIcon,
      saveIcon,
      summeryIcon,
      partnerIcon,
      businessIcon,
      usersIcon,
      offersIcon,
      ordersIcon,
      commissionIcon,
      messageIcon,
    },
    mixins: [validationMixin],
  })

  export default class Details extends mixins(sideMenuPartnerMixin) {
    public returnIcon: object = returnIcon;
    public saveIcon: object = saveIcon;
    public showSomething: boolean = false;
    public timeout?: number;
    public data: {
      id: string|null,
      addressContext: any,
      personId: any,
      attention: any,
      street: any,
      houseNumber: any,
      houseNumberExtension: any,
      postalCode: any,
      city: any,
    } = {
      id: null,
      addressContext: null,
      personId: null,
      attention: null,
      street: null,
      houseNumber: null,
      houseNumberExtension: null,
      postalCode: null,
      city: null,
    };

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          addressContext: {required},
          street: {required},
          houseNumber: {required, houseNumber},
          houseNumberExtension: {},
          postalCode: {required, postalCode},
          city: {required},
        },
      };
    }

    get addressDetailsClass() {
      let value = 'partner-add';

      if (this.showSomething) {
        value += ' no-scroll-container';
      }

      return value;
    }

    get addressData(): {
      id: any,
      addressContext: any,
      attention: any,
      street: any,
      houseNumber: any,
      houseNumberExtension: any,
      postalCode: any,
      city: any,
    } {
      return this.data;
    }

    get addressContextList() {
      return [
        {value: 'main', label: 'Bezoekadres'},
        {value: 'postal', label: 'Postadres'},
        {value: 'invoice', label: 'Factuuradres'},
        {value: 'product', label: 'Aansluitadres'},
        {value: 'delivery', label: 'Bezorgadres'},
      ];
    }

    get currentAddressType() {
      const addressContexts = this.addressContextList;
      const currentAddressType = this.addressData.addressContext;

      if (currentAddressType !== null) {
        const foundKey: any = Object.keys(addressContexts).find((key) =>
          // @ts-ignore-next-line
          addressContexts[key].value === currentAddressType);

        return foundKey != null ? addressContexts[foundKey] : null;
      }

      return null;
    }

    get headerTitle(): string {
      return (this.$route.params.addressId !== undefined) ? 'Adres wijzigen' : 'Adres toevoegen';
    }

    public inputFieldChanged(field: any) {
      const name: string = field.id;
      // @ts-ignore-next-line
      this.data[name] = field.value;
    }

    public addressTypeFieldChanged(field: any) {
      this.data.addressContext = field.value;
    }

    public addressDetails(): Promise<boolean> {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('setLoadOverlay', true);

        const url = '/-/trade/api/partner.address.info';
        const data = {
          personId: this.$route.params.pid,
          id: this.$route.params.addressId,
        };

        axios.post(url, {
          id: data.id,
        }).then(
          (response) => {
            this.$store.dispatch('setLoadOverlay', false);
            this.data = response.data;
          },
          (error) => {
            this.$store.dispatch('setLoadOverlay', false);
          },
        );
      });
    }

    public created() {
      if (this.$route.params.addressId) {
        this.addressDetails();
      }

      this.buildSideMenuPartner();
    }

    public processAddress() {
      this.$v.$touch();

      if (! this.data.personId) {
        this.data.personId = this.$route.params.pid;
      }

      if (! this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);
        const url = '/-/trade/api/partner.address.save';

        axios
          .post(url, this.addressData).then(
          (response) => {
            this.$toast({
              icon: saveIcon,
              text: 'Adres opgeslagen',
              theme: 'success',
            });

            this.data = response.data;
            this.$store.dispatch('setLoadOverlay', false);
          },
          (error) => {
            this.$store.dispatch('setLoadOverlay', false);
          },
        );
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public canSavePartnerAddress(): boolean {
      if (
          this.addressData?.id
          && this.$store.getters.getUser.privileges.includes('update-address')
      ) {
        return true;
      }

      if (
          this.addressData?.id === null
          && this.$store.getters.getUser.privileges.includes('create-address')
      ) {
        return true;
      }

      return false;
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';
</style>
